export enum CardType {
    boom = 'boom',
    zap = 'zap',
    lock = 'lock',
    key = 'key',
    plus_three = 'plus_three',
    value = 'value',
    rock = 'anchor',
    scissors = 'scissors',
    tornado = 'tornado',
    joker = 'joker',
    gold = 'gold',
    canister_pre_booster = 'canister_pre_booster',
    joker_pre_booster = 'joker_pre_booster',
    plinko = 'plinko',
}
